export const stripHtmlTags = (str: string | null | undefined) => {
  if (!str || typeof str !== 'string') {
    return '';
  }

  return str
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/&nbsp;/g, ' ') // Replace &nbsp; with regular space
    .replace(/&amp;/g, '&') // Replace &amp; with &
    .replace(/&lt;/g, '<') // Replace &lt; with <
    .replace(/&gt;/g, '>') // Replace &gt; with >
    .replace(/&quot;/g, '"') // Replace &quot; with "
    .replace(/&#39;/g, "'") // Replace &#39; with '
    .replace(/&[#\w]+;/g, '') // Remove any remaining HTML entities
    .trim(); // Remove leading/trailing whitespace
};
